import { useEffect, useRef } from 'react'
import { useSearchParams, useNavigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useSSOTokenExchange } from '@/hooks/useLogin'
import { SSO_REDIRECT_URI } from '@/config/env'

export default function AuthCallback() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const { mutate: exchangeToken } = useSSOTokenExchange()
  const hasRun = useRef(false)

  useEffect(() => {
    if (hasRun.current) return
    hasRun.current = true

    const code = searchParams.get('code')
    const state = searchParams.get('state')
    const error = searchParams.get('error')
    const errorDescription = searchParams.get('error_description')

    if (error) {
      navigate('/login', {
        replace: true,
        state: { ssoError: errorDescription || error },
      })
      return
    }

    const savedState = sessionStorage.getItem('sso_state')
    const codeVerifier = sessionStorage.getItem('sso_code_verifier')

    sessionStorage.removeItem('sso_state')
    sessionStorage.removeItem('sso_code_verifier')

    if (!code || !codeVerifier || state !== savedState) {
      navigate('/login', {
        replace: true,
        state: {
          ssoError: 'Invalid authentication response. Please try again.',
        },
      })
      return
    }

    exchangeToken(
      { code, redirectUri: SSO_REDIRECT_URI, codeVerifier },
      {
        onError: () => {
          navigate('/login', {
            replace: true,
            state: { ssoError: 'Authentication failed. Please try again.' },
          })
        },
      }
    )
  }, [searchParams, exchangeToken, navigate])

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <p className="text-muted-foreground">Authenticating...</p>
      </div>
    </div>
  )
}
